import { render, staticRenderFns } from "./CadastroStatusLaudo.vue?vue&type=template&id=fe0f9610&"
import script from "./CadastroStatusLaudo.vue?vue&type=script&lang=js&"
export * from "./CadastroStatusLaudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports